/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_Modal_SubtitleInputs */

const en_upgrade_modal_subtitle = /** @type {(inputs: Upgrade_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock ultra-high performance tools designed for scaling professional marketplaces.`)
};

const es_upgrade_modal_subtitle = /** @type {(inputs: Upgrade_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquea herramientas de ultra alto rendimiento diseñadas para escalar mercados profesionales.`)
};

const fr_upgrade_modal_subtitle = /** @type {(inputs: Upgrade_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloquez des outils ultra-performants conçus pour faire évoluer les places de marché professionnelles.`)
};

const de_upgrade_modal_subtitle = /** @type {(inputs: Upgrade_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schalte hochleistungsfähige Tools frei, die für die Skalierung professioneller Marktplätze entwickelt wurden.`)
};

const id_upgrade_modal_subtitle = /** @type {(inputs: Upgrade_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka alat performa sangat tinggi yang dirancang untuk skala marketplace profesional.`)
};

/** @type {(inputs: Upgrade_Modal_SubtitleInputs) => LocalizedString} */
const ja_upgrade_modal_subtitle = en_upgrade_modal_subtitle;

/** @type {(inputs: Upgrade_Modal_SubtitleInputs) => LocalizedString} */
const zh_upgrade_modal_subtitle = en_upgrade_modal_subtitle;

/** @type {(inputs: Upgrade_Modal_SubtitleInputs) => LocalizedString} */
const ar_upgrade_modal_subtitle = en_upgrade_modal_subtitle;

/** @type {(inputs: Upgrade_Modal_SubtitleInputs) => LocalizedString} */
const it_upgrade_modal_subtitle = en_upgrade_modal_subtitle;

/** @type {(inputs: Upgrade_Modal_SubtitleInputs) => LocalizedString} */
const ru_upgrade_modal_subtitle = en_upgrade_modal_subtitle;

/** @type {(inputs: Upgrade_Modal_SubtitleInputs) => LocalizedString} */
const pt_upgrade_modal_subtitle = en_upgrade_modal_subtitle;

/** @type {(inputs: Upgrade_Modal_SubtitleInputs) => LocalizedString} */
const ko_upgrade_modal_subtitle = en_upgrade_modal_subtitle;

/**
* | output |
* | --- |
* | "Unlock ultra-high performance tools designed for scaling professional marketplaces." |
*
* @param {Upgrade_Modal_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_modal_subtitle = /** @type {((inputs?: Upgrade_Modal_SubtitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Modal_SubtitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_modal_subtitle(inputs)
	if (locale === "es") return es_upgrade_modal_subtitle(inputs)
	if (locale === "fr") return fr_upgrade_modal_subtitle(inputs)
	if (locale === "de") return de_upgrade_modal_subtitle(inputs)
	if (locale === "ja") return ja_upgrade_modal_subtitle(inputs)
	if (locale === "zh") return zh_upgrade_modal_subtitle(inputs)
	if (locale === "ar") return ar_upgrade_modal_subtitle(inputs)
	if (locale === "id") return id_upgrade_modal_subtitle(inputs)
	if (locale === "it") return it_upgrade_modal_subtitle(inputs)
	if (locale === "ru") return ru_upgrade_modal_subtitle(inputs)
	if (locale === "pt") return pt_upgrade_modal_subtitle(inputs)
	return ko_upgrade_modal_subtitle(inputs)
});